import headerImgEn from "assets/images/v124/header-en.webp"
import infoImgEn from "assets/images/v124/info-en.webp"

export const v124ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
